// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2rCW3","colMaxWidth":"Table_colMaxWidth__20eSN"};